// extracted by mini-css-extract-plugin
module.exports = {"root":"autocomplete-item-remove_root__C9G7s","icon":"autocomplete-item-remove_icon__Y_AnZ"};